// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import type { StrongOmit } from '@evolvemep/api-ts';

import { useUpdateGlobalFilters } from 'components/Mantine/GlobalFilters/useGlobalFilters';
import { TimeFramePicker, type TimeFramePickerProps } from 'components/Mantine/TimeFramePicker/TimeFramePicker';

export const TimeFrameRequired = (props: StrongOmit<TimeFramePickerProps, 'value' | 'onChange'>) => {
  const { updateGlobalFilters, globalFilters, filterConfig } = useUpdateGlobalFilters();
  return (
    <TimeFramePicker
      value={globalFilters.timeFrame}
      onChange={(timeFrame) => updateGlobalFilters({ timeFrame })}
      timeFrameOptions={filterConfig?.timeFrame?.options}
      timeFrameGroups={filterConfig?.timeFrame?.groups}
      {...props}
    />
  );
};
